export const sendEmail = async (sender:string, recipient:string[],htmlBody:string, subject:string, ) => {
    const path = `https://sj1w0km1ad.execute-api.ap-south-1.amazonaws.com/prod/sendEmail`;  // Define the API endpoint path
    
    const data = {
      sender: sender,        // Dynamic sender email
      recipient: recipient,  // Dynamic recipient email
      subject: subject,      // Dynamic subject
      htmlBody: htmlBody     // Dynamic HTML body content
    };

    try {
      // Send POST request to the API
      const response = await fetch(path, {
        method: 'POST',  // HTTP method
        headers: {
          'Content-Type': 'application/json',  // Set the content type to JSON
        },
          body: JSON.stringify({
              sender: sender,        // Dynamic sender email
            recipient: recipient,  // Dynamic recipient email
            subject: subject,      // Dynamic subject
            htmlBody: htmlBody}),  // Stringify the dynamic data to send in the request body
      });

      // Check if the response is OK (status 200)
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      // Parse the JSON response from the API
      const result = await response.json();
  
      // Return the result
      return result;
    } catch (error) {
      console.error('Error sending email:', error);
      return { error: "Error sending email" };  // Return error if any
    }
};
